// Author(s): Dave Mills, Luke Golding, Ryan O'Neill
// description: This is the main application file for the CST Calendar App.
// It now uses React Router to handle navigation between the booking page and confirmation page.
// The app allows users to book appointments with assessors and shows a separate confirmation page
// after successful booking to prevent confusion and additional bookings.
// license: Proprietary
// app.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BookingPage from './BookingPage';
import ConfirmationPage from './ConfirmationPage';
import RequestMeetingPage from './RequestMeetingPage';

// --- Main Application Component ---
function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<BookingPage />} />
                <Route path="/confirmation" element={<ConfirmationPage />} />
                <Route path="/request-meeting" element={<RequestMeetingPage />} />
            </Routes>
        </Router>
    );
}

// Add the CSS styles that were previously in the main component
const style = document.createElement('style');
style.textContent = `
    @keyframes fade-in {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
    }
    .animate-fade-in {
        animation: fade-in 0.5s ease-out forwards;
    }
    
    /* Custom Scrollbar Styles */
    .custom-scrollbar::-webkit-scrollbar {
        width: 8px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-track {
        background: #374151;
        border-radius: 4px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #6b7280;
        border-radius: 4px;
        transition: background-color 0.2s ease;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #3b82f6;
    }
    
    /* Firefox scrollbar */
    .custom-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: #6b7280 #374151;
    }
    
    /* Smooth scrolling */
    .custom-scrollbar {
        scroll-behavior: smooth;
    }
`;
document.head.appendChild(style);

export default App;
